import React from 'react';

import * as AuditService from '../../../services/audit/admin/Audit';

const AuditContext = React.createContext();
const { Provider, Consumer } = AuditContext;

class AuditProvider extends React.Component {
  state = {
    response: null,
  };

  constructor(props) {
    super(props);
    this.home = this.home.bind(this);
    this.getAuditRecord = this.getAuditRecord.bind(this);
  }

  async home(data) {
    return new Promise(async (resolve, reject) => {
      await AuditService.home(data)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  async getAuditRecord(id) {
    return new Promise(async (resolve, reject) => {
      await AuditService.getAuditRecord(id)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  render() {
    const { children } = this.props;

    return (
      <Provider
        value={{
          response: this.state.response,
          home: this.home,
          getAuditRecord: this.getAuditRecord,
        }}
      >
        {children}
      </Provider>
    );
  }
}

export default AuditContext;

export { AuditProvider, Consumer };
